import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  availableEmployees: [],
  selectedEmployees: [],
};

const dragDropSlice = createSlice({
  name: 'dragDrop',
  initialState,
  reducers: {
    setAvailableEmployees: (state, action) => {
      state.availableEmployees = Array.isArray(action.payload) ? action.payload : [];
    },
    setSelectedEmployees: (state, action) => {
      state.selectedEmployees = Array.isArray(action.payload) ? action.payload : [];
    },
    moveEmployee: (state, action) => {
      const { source, destination } = action.payload;
      
      // Moving within the same list
      if (source.droppableId === destination.droppableId) {
        const items = source.droppableId === 'allEmployees' ? state.availableEmployees : state.selectedEmployees;
        const [movedItem] = items.splice(source.index, 1);
        items.splice(destination.index, 0, movedItem);
      } else {
        // Moving between lists
        const sourceItems = source.droppableId === 'allEmployees' ? state.availableEmployees : state.selectedEmployees;
        const destItems = destination.droppableId === 'allEmployees' ? state.availableEmployees : state.selectedEmployees;
        const [movedItem] = sourceItems.splice(source.index, 1);
        destItems.splice(destination.index, 0, movedItem);
      }
    },
  },
});

export const { setAvailableEmployees, setSelectedEmployees, moveEmployee } = dragDropSlice.actions;
export default dragDropSlice.reducer; 